module.exports = __webpack_public_path__ + "static/environmental-stewardship-desktop.6861cd79.webp";